import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import axios, { removeBracketedText } from '../Axiosinstance';
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast, ToastContainer } from 'react-toastify';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import courserecipt from '../pdf/courserecipt.pdf'
import 'jspdf-autotable';
import { Modal, Box, Typography, CircularProgress } from "@mui/material";
import Button from '@mui/material/Button';
import fontkit from '@pdf-lib/fontkit';  // Import fontkit for custom fonts
import TimesRoman from '../fonts/times.ttf'
const Fees = () => {
    const [search, setSearch] = useState('');
    const [details, setDetails] = useState(true);
    const [responseData, setResponseData] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [showDiscountField, setShowDiscountField] = useState(false);
    const [loading, setLoading] = useState(false); // State for loader
    const [registrationFeebalance, setRegistrationFeebalance] = useState('');
    const [courseFeebalance, setCourseFeebalance] = useState('');
    const [isCheckboxEnabled, setIsCheckboxEnabled] = useState(false);
     const [selectedStudent, setSelectedStudent] = useState(null);


    const [formData, setFormData] = useState({
        // invoiceNumber: "INV123456",
        date: '',
        studentName: '',
        feestype: '',
        finNric: '',
        course: '',
        description: '',
        amount: 0,
        discount: 0,
        status: ''
    });

    const [courses, setCourses] = useState([]);

    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        setShowDiscountField(isChecked);
        if (!isChecked) {
            // Reset discount field if checkbox is unchecked
            setFormData((prevData) => ({ ...prevData, discount: 0 }));
        }
    };

    // State for controlling checkbox

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const response = await axios.get('batches'); // Replace with your API URL
                setCourses(response.data); // Assuming the response data is an array of course objects
            } catch (error) {
                console.error('Error fetching courses:', error);
            }
        };

        fetchCourses();
    }, []);

    // Watch for changes in `feestype` and update description
    useEffect(() => {
        if (formData.feestype === "Course fee") {
            setFormData((prevData) => ({
                ...prevData,
                description: "Learning Support Agent Fees for Distance Learning Course",
            }));
        } else if (formData.feestype === "Registration fee") {
            setFormData((prevData) => ({
                ...prevData,
                description: "Application Fees for Distance Learning Course",
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                description: "",
            }));
        }
    }, [formData.feestype]);


    const fetchData = async () => {
        try {
            const response = await axios.get('registrationadvances/registration/search', {
                params: {
                    nric: search,
                }
            });
            const data = response.data;
            setSelectedStudent(data)
            console.log('Error fetching:', data);
            const currentDate = new Date().toISOString();
            if (data) {
                // Extract the fee balances (you may need to adjust the property names based on your API response)
                setRegistrationFeebalance(data.remainingRegistrationFee);
                setCourseFeebalance(data.remainingCourseFee)

                // Compare fetched course with courses array
                const matchingCourse = courses.find((course) => course.course === data.course);
                // Update formData with the fetched data
                setFormData({
                    date: currentDate,
                    studentName: data.name || '',
                    finNric: data.nric || '',
                    status: data.status || '',
                    course: matchingCourse
                        ? `${matchingCourse.course}(${matchingCourse.id})`
                        : '',
                });
            }
            setDetails(false);
        } catch (error) {
            console.error('Error fetching:', error);
            toast.error('user not found');
        }
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const handleSearchClick = () => {
        if (search.trim() !== '') {
            fetchData(); // Call fetchData to perform the search
        } else {
            toast.error('Please enter a NRIC/FIN');
        }
    };

    const handleResetClick = () => {
        setSearch('');
        setDetails(true); // Reset to enable fields
        setFormData({
            date: '',
            studentName: '',
            feestype: '',
            finNric: '',
            course: '',
            description: '',
            amount: 0,
            discount: 0,
            status: ''
        });
        setRegistrationFeebalance(0);
        setCourseFeebalance(0);
        setIsSubmitted(false);
    };

    const [errors, setErrors] = useState({
        amount: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        console.log(name, value, typeof value); // Debugging: Check name, value, and its type
        const onlyNumberRegex = /^[0-9]*$/; // Regex to allow only numbers
        let errorMessage = "";

        // Check if the input is for amount or discount and validate
        if (name === "amount" || name === "discount") {
            if (!onlyNumberRegex.test(value)) {
                errorMessage = "Only numbers are allowed.";
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: errorMessage,
                }));
                return; // Exit if there's an error
            } else {
                errorMessage = ""; // Clear error if valid
            }
        }

        // Update error state
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMessage,
        }));

        // Update student data only if validation passes
        if (!errorMessage) {
            setFormData({
                ...formData,
                [name]: (name === "amount" || name === "discount") ? Number(value) : value, // Convert to number for amount and discount
            });
        }

        // Enable or disable checkbox based on 'feestype' selection
        if (name === "feestype") {
            const isCourseFee = value === "Course fee";
            setIsCheckboxEnabled(isCourseFee); // Enable only for "Course fee"

            if (!isCourseFee) {
                setShowDiscountField(false); // Hide discount field
                setFormData((prevData) => ({ ...prevData, discount: 0 })); // Reset discount
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const currentDate = new Date().toISOString(); // Get the current date in ISO format

        const enteredAmount = parseFloat(formData.amount);
        const enteredDiscount = parseFloat(formData.discount || 0); // Default to 0 if discount is empty
        const totalAmount = enteredAmount + enteredDiscount; // Calculate total amount

        const registrationBalance = parseFloat(registrationFeebalance);
        const courseBalance = parseFloat(courseFeebalance);

        // Check if all required fields are filled
        if (!formData.studentName || !formData.feestype || !formData.finNric || !formData.course || !formData.amount) {
            setLoading(false);
            toast.error("All fields are required.");
            return;
        }

        // Check if the total amount exceeds the balances
        if (totalAmount > registrationBalance && formData.feestype === "Registration fee") {
            setLoading(false);
            toast.error("Total amount exceeds the Registration Fee Balance.");
            return;
        }

        if (totalAmount > courseBalance && formData.feestype === "Course fee") {
            setLoading(false);
            toast.error("Total amount exceeds the Course Fee Balance.");
            return;
        }

        try {
            // Update the formData with the current date before submission
            const updatedFormData = {
                ...formData,
                date: currentDate
            };

            const response = await axios.post('registrationadvances/addRegistrationFee', updatedFormData);
            console.log('Response:', response.data);
            setResponseData(response.data);
            toast.success('Payment success');
            setIsSubmitted(true);

            // Update state with fee balances
            setRegistrationFeebalance(response.data.registrationFeebalance || 0);
            setCourseFeebalance(response.data.courseFeebalance || 0);
        } catch (error) {
            console.error('Error submitting Payment:', error);
            toast.error('Failed to submit the Payment');
        } finally {
            setLoading(false); // Hide loader
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if necessary
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1 and pad
        const year = date.getFullYear(); // Get full year

        return `${day}/${month}/${year}`;
    };

    const numberToWords = (number) => {
        const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
        const suffixes = ['', 'Thousand'];


        const numToWords = (num) => {
            let words = '';
            if (num >= 1000) {
                words += numToWords(Math.floor(num / 1000)) + ' Thousand ';
                num %= 1000;
            }
            if (num >= 100) {
                words += ones[Math.floor(num / 100)] + ' Hundred ';
                num %= 100;
            }
            if (num >= 20) {
                words += tens[Math.floor(num / 10)] + ' ';
                num %= 10;
            }
            if (num > 0) {
                if (num >= 11 && num <= 19) {
                    words += teens[num - 10] + ' ';
                } else {
                    words += ones[num] + ' ';
                }
            }
            return words.trim();
        };

        if (number === 0) return 'Zero';
        return numToWords(number);
    };


    const handleDownload = async (e,selectedStudent) => {

        e.preventDefault(); // Prevent the default form submission behavior

        try {
            const pdfBytes = await fetch(courserecipt).then((res) => res.arrayBuffer());
            const pdfDoc = await PDFDocument.load(pdfBytes);
            pdfDoc.registerFontkit(fontkit);
            const pages = pdfDoc.getPages();
            const firstPage = pages[0];

            // const courierfont = await pdfDoc.embedFont(StandardFonts.Courier);
            //const courierfontbold = await pdfDoc.embedFont(StandardFonts.CourierBold);
            const calibriFontBoldBytes = await fetch(TimesRoman).then((res) => res.arrayBuffer());
            const courierfont = await pdfDoc.embedFont(calibriFontBoldBytes);


            const amountText = responseData?.amount ? `$${(responseData.amount).toFixed(2)}` : ''; // Ensure the dollar symbol is always present
            const type = responseData?.feestype;
            let label = '';
            let labelX = 318;

            if (type === 'Registration fee') {
                label = 'Registration Fees';
                labelX = 317;
            } else if (type === 'Course fee') {
                label = 'Course Fees';
                labelX = 335;
            } else {
                label = '';

            }

            const balanceToDisplay = responseData?.feestype === 'Course fee'
                ? responseData?.courseFeebalance?.toFixed(2)
                : responseData?.registrationFeebalance?.toFixed(2);
            const sumOfDollars = numberToWords(responseData?.amount);
            // Convert numbers to strings
            firstPage.drawText(String(responseData?.studentName || '').toUpperCase(), { x: 128, y: 572, size: 10, font: courierfont, color: rgb(0, 0, 0) });
            firstPage.drawText(String(responseData?.finNric || ''), { x: 128, y: 558, size: 10, font: courierfont, color: rgb(0, 0, 0) });
            firstPage.drawText(String(selectedStudent?.studentIds || ''), { x: 133, y: 545, size: 10, font: courierfont, color: rgb(0, 0, 0) });
            firstPage.drawText(String(selectedStudent?.email || ''), { x: 115, y: 504, size: 10, font: courierfont, color: rgb(0, 0, 0) });
            function wrapText(text, font, fontSize, maxWidth) {
                const words = text.split(' ');
                const lines = [];
                let currentLine = '';

                for (let i = 0; i < words.length; i++) {
                    const word = words[i];
                    const testLine = currentLine ? currentLine + ' ' + word : word;
                    const textWidth = font.widthOfTextAtSize(testLine, fontSize);

                    if (textWidth <= maxWidth) {
                        currentLine = testLine;
                    } else {
                        if (currentLine) lines.push(currentLine);
                        currentLine = word;
                    }
                }

                if (currentLine) lines.push(currentLine);
                return lines;
            }

            // 3. Apply it in PDF-lib drawing
            const rawCourseName = responseData?.course || '';
            const cleanedCourseName = removeBracketedText(rawCourseName);

            const maxWidth = 150;
            const fontSize = 10;
            const startX = 128;
            let startY = 531;

            const lines = wrapText(cleanedCourseName, courierfont, fontSize, maxWidth);

            lines.forEach((line) => {
                firstPage.drawText(line, {
                    x: startX,
                    y: startY,
                    size: fontSize,
                    font: courierfont,
                    color: rgb(0, 0, 0),
                });
                startY -= fontSize + 2; // Move down for the next line
            });
            // firstPage.drawText(String(feeDetail?.description || ''), { x: 35, y: 520, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
            firstPage.drawText(String(responseData?.invoiceNumber || ''), { x: 467, y: 569, size: 12, font: courierfont, color: rgb(0, 0, 0) });
            firstPage.drawText(String(formatDate(responseData?.date || '')), { x: 477, y: 466, size: 10, font: courierfont, color: rgb(0, 0, 0) });
            firstPage.drawText(amountText, { x: 485, y: 384, size: 10, font: courierfont, color: rgb(0, 0, 0) });
            firstPage.drawText(amountText, { x: 485, y: 319, size: 10, font: courierfont, color: rgb(0, 0, 0) });
            firstPage.drawText(label, { x: labelX, y: 371, size: 10, font: courierfont, color: rgb(0, 0, 0) });
            firstPage.drawText(String(formatDate(responseData?.date || '')), { x: 85, y: 384, size: 10, font: courierfont, color: rgb(0, 0, 0) });
            // firstPage.drawText(amountText, { x: 497, y: 460, size: 10, font: courierfont, color: rgb(0, 0, 0) });
            // firstPage.drawText(`${sumOfDollars} Dollars Only`, { x: 177, y: 464, size: 11, font: courierfontbold, color: rgb(0, 0, 0) });
            // firstPage.drawText("AUD", { x: 498, y: 438, size: 1, font: courierfont, color: rgb(0, 0, 0) });
            firstPage.drawText(`S$${balanceToDisplay}`, { x: 483, y: 291, size: 10, font: courierfont, color: rgb(0, 0, 0) });

            // const drawWrappedText = async (page, text, x, y, font, fontSize, maxWidth) => {
            //     text = replaceTabs(text);
            //     const lines = [];
            //     let currentLine = '';
            //     const words = text.split(' ');

            //     for (let i = 0; i < words.length; i++) {
            //         const word = words[i];
            //         const width = getTextWidth(currentLine + ' ' + word, font, fontSize);

            //         if (width < maxWidth) {
            //             currentLine += (currentLine === '' ? '' : ' ') + word;
            //         } else {
            //             lines.push(currentLine.trim());
            //             currentLine = word;
            //         }
            //     }

            //     if (currentLine !== '') {
            //         lines.push(currentLine.trim());
            //     }

            //     for (let i = 0; i < lines.length; i++) {
            //         const line = lines[i].trim();
            //         const lineWidth = getTextWidth(line, font, fontSize);

            //         await page.drawText(line, {
            //             x: i === 0 ? x : x,
            //             y: y - i * 12,
            //             size: fontSize,
            //             font,
            //             color: rgb(0, 0, 0),
            //         });
            //     }
            // };

            // function replaceTabs(text) {
            //     return text.replace(/\t/g, '    '); // Replace each tab with four spaces
            // }

            // const getTextWidth = (text, font, fontSize) => {
            //     const width = font.widthOfTextAtSize(text, fontSize);
            //     return width;
            // };

            // let yPosition = 520;
            // const lineHeight = 10;

            // drawWrappedText(firstPage, String(feeDetail?.description || ''), 77, yPosition, courierfontbold, 10, 380);
            // yPosition -= lineHeight;

            // drawWrappedText(firstPage, `${sumOfDollars} Dollars Only`, 177, 464, courierfontbold, 10, 300);

            const pdfBytesModified = await pdfDoc.save();
            const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
        } catch (error) {
            console.error('Error generating PDF:', error);
            toast.error('Failed to generate PDF');
        }
    };



    return (
        <div>
            <Header />
            <br />
            <br />
            <br />
            <h4 style={{ textAlign: 'center' }} >Course Fees / Registration Fees (Newton International College)</h4>
            <br />
            <div className="containerd mx-auto" style={{ maxWidth: '1000px', padding: '20px', color: 'black', background: '#FAF9F6', borderRadius: '15px', marginBottom: '20px' }}>
                <Modal open={loading} aria-labelledby="loading-modal" aria-describedby="loading-description">
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 400,
                            bgcolor: "background.paper",
                            boxShadow: 24,
                            p: 4,
                            borderRadius: 2,
                            textAlign: "center",
                        }}
                    >
                        <CircularProgress color="primary" />
                        <Typography id="loading-description" sx={{ mt: 2 }}>
                            Please wait while the email is sent.
                        </Typography>
                    </Box>
                </Modal>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                    <input
                        type="text"
                        placeholder="Search by ID"
                        value={search}
                        onChange={handleSearchChange}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                handleSearchClick();
                            }
                        }}
                        style={{
                            padding: '10px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            flex: '1',
                            fontSize: '16px',
                            marginRight: '10px'
                        }}
                    />
                    <Button variant='contained' color='primary' onClick={handleSearchClick} style={{ padding: '10px 20px' }}>
                        Search
                    </Button>
                    <Button variant='contained' color='primary' onClick={handleResetClick} style={{ marginLeft: '10px', padding: '10px 20px' }}>
                        Reset
                    </Button>
                </div>

                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '10px',
                        backgroundColor: '#f1f1f1',
                        borderRadius: '6px',
                        border: '1px solid #ced4da',
                        marginBottom: '20px',
                    }}
                >
                    <h5 style={{ margin: '0', fontSize: '18px', fontWeight: 'bold' }}>Balance Fee Details</h5>
                    <div style={{ display: 'flex', gap: '20px' }}>
                        <p style={{ margin: 0, fontSize: '16px' }}>
                            <strong>Registration Fee Balance: {registrationFeebalance}</strong>
                        </p>
                        <p style={{ margin: 0, fontSize: '16px' }}>
                            <strong>Course Fee Balance: {courseFeebalance}</strong>
                        </p>
                    </div>

                </div>
                <form

                    style={{ display: 'flex', flexDirection: 'row' }} >
                    <div style={{ marginRight: '20px', flex: 1 }}>
                        <div className="form-grup">
                            <label htmlFor="studentName">Student Name*</label>
                            <input
                                type="text"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                id="StudentName"
                                className="form-control"
                                name="studentName"
                                value={formData.studentName}  // Corrected
                                onChange={handleChange}
                                required
                                disabled={!details}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="finNric">NRIC/FIN NO*</label>
                            <input
                                type="text"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                id="finNric"
                                name="finNric"
                                className="form-control"
                                value={formData.finNric}
                                onChange={handleChange}
                                disabled={!details}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="course">Course</label>
                            <select
                                id="course"
                                className="form-control"
                                style={{ width: '100%', height: '46px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                name="course"
                                value={formData.course}
                                onChange={handleChange}
                                required
                                disabled={!details}
                            >
                                <option value="">Select a course</option>
                                {courses.map((course) => (
                                    <option key={course.id} value={`${course.course}(${course.id})`}>
                                        {course.course}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {/* <input
                            type="text"
                            name="course"
                            value={formData.course}
                            onChange={handleChange}
                        /> */}

                        <div className="form-group">
                            <label htmlFor="Feestype">Fees Type</label>
                            <select
                                id="Feestype"
                                className="form-control"
                                style={{ width: '100%', height: '46px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                name="feestype"
                                value={formData.feestype}
                                onChange={handleChange}
                                required
                            // disabled={!details}
                            >
                                <option value="">Select a Type</option>
                                <option value="Course fee">Course fee</option>
                                <option value="Registration fee">Registration fee</option>
                            </select>

                        </div>

                        <div className="form-group">
                            <label htmlFor="description">Description</label>
                            <input
                                type="text"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                id="description"
                                name="description"
                                className="form-control"
                                value={formData.description}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="amount">Amount</label>
                            <input
                                type="text"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                id="amount"
                                name="amount"
                                className="form-control"
                                value={formData.amount}
                                onChange={(e) => {
                                    // Only allow numbers (no periods or decimals)
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                        handleChange(e);
                                    }
                                }}
                                required
                            />
                            {errors.officephone && <p style={{ color: "red" }}>{errors.officephone}</p>}
                        </div>

                        <div className="form-group">
                            <label>
                                <input
                                    type="checkbox"
                                    style={{ marginRight: "10px" }}
                                    onChange={handleCheckboxChange}
                                    checked={showDiscountField}
                                    disabled={!isCheckboxEnabled} // Disable if not "Course fee"
                                />
                                Apply Discount
                            </label>
                        </div>

                        {showDiscountField && (
                            <div className="form-group">
                                <label htmlFor="discount">Discount Amount</label>
                                <input
                                    type="number"
                                    style={{
                                        width: '100%',
                                        height: '42px',
                                        borderRadius: '6px',
                                        border: '1px solid #ced4da',
                                    }}
                                    id="discount"
                                    name="discount"
                                    className="form-control"
                                    value={formData.discount}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        )}
                        <br />
                        <Button variant='contained' color='primary' onClick={handleSubmit} disabled={isSubmitted}>
                            Submit
                        </Button>
                        {isSubmitted && (
                            <Button
                                variant="contained"
                                color="primary"
                               onClick={(e) => handleDownload(e, selectedStudent)}
                                sx={{ marginLeft: '10px' }}
                            >
                                View Receipt
                            </Button>
                        )}

                    </div>
                </form>

                <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
            </div>
        </div>
    );
};


export default Fees;
